import React, { useState } from "react";
import { message, Modal, Upload } from "antd";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { user } from "../../services";
import {
  getUserInfo,
  resetUpdateStatus,
} from "../../redux/reducers/slice/profile";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

function getBase64(img: any, callback: any) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

const UploadAvatarModal = (props: any) => {
  const { src, handleChangeAvatar, visible, closeUploadAvatarModal } = props;
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(src || "");
  const [data, setData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (visible) {
      setImageUrl(src || "");
    }
  }, [visible]);

  function beforeUpload(file: any) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
      return false;
    }

    getBase64(file, (imageUrl: any) => {
      setImageUrl(imageUrl);
    });

    return true;
  }

  const customRequest = (info: any) => {
    setData(info.file);
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();

    formData.append("files", data);
    formData.append("folder_name", "avatar");
    formData.append("folder_id", "612460fc054beb7787ad07ce");

    user.updateAvatar(formData, (data, error) => {
      if (data) {
        dispatch(resetUpdateStatus());
        dispatch(getUserInfo());
        handleChangeAvatar(data.avatar);
        setLoading(false);
        closeUploadAvatarModal();
      }

      if (error) {
        console.log("error: ", error);
      }
    });
  };

  return (
    <Modal
      title="Cập nhật ảnh đại diện"
      visible={visible}
      width={800}
      okText="Lưu"
      cancelText="Hủy"
      onOk={handleSubmit}
      onCancel={closeUploadAvatarModal}
      confirmLoading={loading}>
      <Upload
        action=""
        className="avatar-upload"
        listType="picture-card"
        showUploadList={false}
        beforeUpload={beforeUpload}
        customRequest={customRequest}
        iconRender={() => <PlusOutlined />}>
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
        ) : (
          <div>
            <PlusOutlined />
            <div style={{ marginTop: 8 }}>Upload</div>
          </div>
        )}
        <div className="edit-avatar">
          <EditOutlined />
        </div>
      </Upload>
    </Modal>
  );
};

export default UploadAvatarModal;
